import { render, staticRenderFns } from "./CopyrightAssignmentTransferAttachments.vue?vue&type=template&id=08aae452&scoped=true&"
import script from "./CopyrightAssignmentTransferAttachments.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferAttachments.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferAttachments.vue?vue&type=style&index=0&id=08aae452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aae452",
  null
  
)

export default component.exports